import oldSubmitSection from 'e-submission/domain/data-model/form/submit/submitSection'
import { hasReceiptSigned } from '../selectors'

export const creator = ({ oldSubmitSection }) => {
  return (props = {}, selectedRemoteSelling = false, app) => {
    return Object.assign(
      {},
      {
        id: 'submit',
        prefix: 'submit',
        title: 'ส่งข้อมูล',
        label: 'ส่งข้อมูล',
        sections: [oldSubmitSection('submit')],
        exclude: true,
        remoteSection: selectedRemoteSelling,
        disabled: !hasReceiptSigned(app),
      },
      props
    )
  }
}

export const submit = creator({ oldSubmitSection })
